//React - React Dom
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';

//Mui 
import LogoutIcon from '@mui/icons-material/Logout';
import { Collapse, Tooltip } from '@mui/material';
import QuizIcon from '@mui/icons-material/Quiz';
import SupportRoundedIcon from '@mui/icons-material/SupportRounded';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LanIcon from '@mui/icons-material/Lan';
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupIcon from '@mui/icons-material/Group';
import DescriptionIcon from '@mui/icons-material/Description';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import LanguageIcon from '@mui/icons-material/Language';
import CategoryIcon from '@mui/icons-material/Category';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import HelpIcon from '@mui/icons-material/Help';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import KeyIcon from '@mui/icons-material/Key';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import WidgetsIcon from '@mui/icons-material/Widgets';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { Campaign } from '@mui/icons-material';
import { TrackChanges } from '@mui/icons-material';
import { Bookmark } from '@mui/icons-material';

//Hooks
import { useAuthUser } from '../../../hooks/useAuthUser/useAuthUser';
import { useCryptoData } from '../../../hooks/useCryptoData/useCryptoData';

//Componentes 
import UsersPage from '../administrative/usersPage/userPage';
import UserGroupsPage from '../administrative/usersPage/userGroups/userGroupsPage';
import Manuals from '../../../components/manuais/ListagemManuais/manuals';
import PublicationsPage from '../../../components/helpdesk/publications/publicationsPage/PublicationsPage';
import PageImages from '../../../components/helpdesk/images/pageImages/PageImages'
import PageCategories from '../../../components/helpdesk/categories/pageCategories/pageCategories';
import RequestsPanelPage from '../requestsPages/panelPage/panelPage';
import ClientsPage from '../administrative/clientsPage/clientsPage';
import RequestsPage from '../requestsPages/requestsPage/requestsPage';
import RequestsChartsPage from '../../../features/charts/pages/ChartsPage.tsx';
import { useFetchData } from '../../../hooks/useFetchData/useFetchData';
import dayjs from 'dayjs';
import { useShowMessages } from '../../../hooks/useMessages/useMessages';
import ClientsActualizations from '../administrative/actualizations/clientsListActualizations';
import SystemsTable from '../../../components/actualizations/systemsTable';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import FilesPage from '../administrative/files/filesPage';
import FilesPageCategories from '../administrative/files/pageCategories';
import UsersActualizationsPage from '../administrative/actualizations/usersActualizationsPage';
import CriarPub from '../../../components/helpdesk/publications/publication/Publication';
import { useCryptoSessionStorage } from '../../../hooks/useCryptoSessionStorage';
import Reasons from '../../../components/requests/reasons';
import { consts } from '../../../config/config';
import CloudServicesPage from '../administrative/cloudServices/CloudServicesPage';
import AnnouncementsPage from '../../../components/announcements/page/AnnoucementsPage';
import BlipMonitoringPage from '../../../components/requests/blip-monitoring/blipMonitoringPage';
import BlipAttendantRankingPage from '../../../components/requests/blip-monitoring/BlipAttendantRankingPage';
import RepositoriesPage from '../administrative/repositories/repositoriesPage';
import SystemsPage from '../administrative/systems/systemsPage';
import GitHubIcon from '@mui/icons-material/GitHub';
import AppsIcon from '@mui/icons-material/Apps';
import FinanceiroPanelPage from '../financeiroPages/panelPage/financeiroPanelPage';
import FinanceiroReportsPage from '../financeiroPages/reportsPage/financeiroReportsPage';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import MoneyIcon from '@mui/icons-material/Money';

const drawerWidth = 240;
const urlDailyPassword = process.env.REACT_APP_API+ "/user/dailyPassword";


const darkTheme = () => {
  let theme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        default: '#3b3b3b',
        paper: '#3b3b3b',
      }
    },
    typography: { 
      htmlFontSize: {xs: 18, sm: 18, md: 15, lg: 15, xl: 15},
      h7: {
        fontSize: '0.7rem',
      }
    },

  });

  // theme.typography.h7 = {
  //   fontSize: '0.7rem',
  //   [theme.breakpoints.up('xl')]: {
  //     fontSize: '',
  //   },
  // };

  return theme;
}


const lightTheme = createTheme({
  palette: {
    mode: 'light',
  },
  typography: { 
    htmlFontSize: {xs: 18, sm: 18, md: 15, lg: 15, xl: 15},
    h7: {
      fontSize: '0.7rem',
    }
  },


});


const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
    overflow: 'hidden',
    padding: 0, 
    //height: '100vh', 
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));





export default function MainPage() {
  const location = useLocation();
  const { state } = location;
  const pageTitle = state?.pageTitle || 'Sirrus Atendimento'; 
  const { getData } = useCryptoSessionStorage();
  const user = getData("user") || {};
  const theme = useTheme();
  const { componentUrl } = useParams();
  const [open, setOpen] = useState(false);
  const [component, setComponent] = useState(<RequestsPanelPage/>);
  const { signOut } = useAuthUser();
  const navigate = useNavigate();
  const [mode, setMode] = useState((localStorage.getItem('theme') === 'dark') ? darkTheme : lightTheme); //
  const { getDataDirectly } = useFetchData();
  
  const { ShowMessage } = useShowMessages();

  //State dos menus expansíveis 
  const [expandedMenu, setExpandedMenu] = useState('');
  const [expandedMenuRequests, setExpandedMenuRequests] = useState(false); 
  const [expandedMenuAtt, setExpandedMenuAtt] = useState(false); 
  const [expandedMenuFiles, setExpandedMenuFiles] = useState(false); 
  const [expandedMenuHelpDesk, setExpandedMenuHelpDesk] = useState(false); 
  const [expandedMenuAdm, setExpandedMenuAdm] = useState(false);
  const [expandedMenuFinanceiro, setExpandedMenuFinanceiro] = useState(false);
  const userGroupLabel = String(
    user?.group_name ||
      user?.group_description ||
      user?.description_group ||
      user?.description ||
      ''
  )
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toUpperCase();
  const isRankingAllowedGroup =
    userGroupLabel === 'DESENVOLVIMENTO' || userGroupLabel === 'ADMINISTRATIVO';
  const canAccessBlipRanking = user?.blip_monitoring === 'Y' && isRankingAllowedGroup;

  // Acesso aos gráficos/painel financeiro liberado apenas para usuários específicos (hardcoded).
  // Independe de grupo/permissão. IDs: 31 (Arthur), 9 (Shelley).
  const FINANCEIRO_ALLOWED_USER_IDS = [31, 9];
  const canAccessFinanceiro = FINANCEIRO_ALLOWED_USER_IDS.includes(Number(user?.id));

  const handleExpandRequests = () => {
    setExpandedMenuRequests(!expandedMenuRequests);
  };
   
  const handleExpandAtt = () => {
    setExpandedMenuAtt(!expandedMenuAtt);
  };  

  const handleExpandFiles = () => {
    setExpandedMenuFiles(!expandedMenuFiles);
  };  

  const handleExpandHelpDesk = () => {
    setExpandedMenuHelpDesk(!expandedMenuHelpDesk);
  };   

  const handleExpandAdm = () => {
    setExpandedMenuAdm(!expandedMenuAdm);
  };

  const handleExpandFinanceiro = () => {
    setExpandedMenuFinanceiro(!expandedMenuFinanceiro);
  };   

  const searchComponent = (component) => {
    switch(component){
      case('atendimentos'): if(user?.requests_list === 'Y'){
        setComponent(<RequestsPage/>);
      }; break;
      case('painel'): if(user?.requests_panel === 'Y') setComponent(<RequestsPanelPage/>); break;
      case('reasons'): if(user?.requests_fr === 'Y') setComponent(<Reasons/>); break;
      case('charts'): if(user?.requests_charts === 'Y') setComponent(<RequestsChartsPage />); break;
      case('blip_attendants_ranking'): if(canAccessBlipRanking) setComponent(<BlipAttendantRankingPage />); break;
      case('actualizations_clients'):{} if(user?.actualizations_panel === 'Y') setComponent(<ClientsActualizations />); break;
      case('actualizations_systems'): if(user?.actualizations_files === 'Y') setComponent(<SystemsTable />); break;
      case('actualizations_users'): if(user?.actualizations_users === 'Y') setComponent(<UsersActualizationsPage />); break;
      case('files'): if(user?.files_panel === 'Y') setComponent(<FilesPage />); break;
      case('files_categories'): if(user?.files_categories === 'Y') setComponent(<FilesPageCategories />); break;
      case('manuais'): setComponent(<Manuals admin={true} />); break;
      case('h'): {if(user?.helpdesk_pubs === 'Y')setComponent(<PublicationsPage setComponent={setComponent} admin={true} />); break;} 
      case('publication'): setComponent(<CriarPub setComponent={setComponent} />); break;
      case('imagens'): if(user?.helpdesk_images === 'Y')setComponent(<PageImages setComponent={setComponent} />); break;
      case('categorias'): if(user?.helpdesk_categories === 'Y')setComponent(<PageCategories setComponent={setComponent} />); break;
      case('usuarios'): if(user?.administration_users === 'Y')setComponent(<UsersPage />); break;
      case('usuariosgrupos'): if(user?.administration_users_groups === 'Y')setComponent(<UserGroupsPage />); break;
      case('clientes'): if(user?.administration_clients === 'Y')setComponent(<ClientsPage />); break;
      case('financeiro'): if(canAccessFinanceiro) setComponent(<FinanceiroPanelPage />); break;
      case('financeiro_relatorios'): if(canAccessFinanceiro) setComponent(<FinanceiroReportsPage />); break;
    }
  }

  useEffect(() => {searchComponent(componentUrl)}, [componentUrl]);
 
  const handleSignout = () => {
    signOut();
    navigate("/admin");  
    window.location.reload(false);
  }

  const handleComponent = (item) => {
    setComponent(item.component);
    navigate(`/admin/${item.to}`, { state: { pageTitle: item.titlePage } });  
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setExpandedMenuHelpDesk(false)
  };


  const handleMode = (theme) => {
    if(theme === 'dark') {
      setMode(darkTheme)
      localStorage.setItem('theme', 'dark');
    } else {
      setMode(lightTheme)   
      localStorage.setItem('theme', 'light');
    }
    
  }

  const getDailyPassword = async () =>{
    const now = dayjs().utc(true).format('DD/MM/YYYY');
    
    getDataDirectly(urlDailyPassword, {user: user.id, date: now}, ((response)=> {
      navigator.clipboard.writeText(response.password);
      ShowMessage('success',  'Copiado para área de transferência'); 
    })
    )
  }


  const buttonsRequests = [
    { 
      id: 1,
      title: 'Painel de Atendimento',
      titlePage: 'Painel de Atendimento',
      component: (<RequestsPanelPage/>),
      icon: (<LanIcon />),
      to: 'painel',
      display: (user?.requests_panel === 'Y') ? '' : 'none',
    },
    { 
      id: 2,
      title: 'Consulta de Atendimentos',
      titlePage: 'Listagem de Atendimentos',
      component: (<RequestsPage />),
      icon: (<PlagiarismIcon />),
      to: 'atendimentos',
      display: (user?.requests_list === 'Y') ? '' : 'none',
    },
    { 
      id: 3,
      title: 'Tipos de Atendimento',
      titlePage: 'Tipos de Atendimento',
      component: (<Reasons />),
      icon: (<Bookmark />),
      to: 'reasons',
      display: (user?.requests_fr === 'Y') ? '' : 'none',
    },
    { 
      id: 4,
      title: 'Gráficos',
      titlePage: 'Gráficos de Atendimentos',
      component: (<RequestsChartsPage />),
      icon: (<BarChartIcon />),
      to: 'charts',
      display: (user?.requests_charts === 'Y') ? '' : 'none',
    },
    {
      id: 5,
      title: 'Ranking de Atendentes Blip',
      titlePage: 'Ranking de Atendentes',
      component: (<BlipAttendantRankingPage />),
      icon: (<TrackChanges />),
      to: 'blip_attendants_ranking',
      display: canAccessBlipRanking ? '' : 'none',
    },
    { 
      id: 6,
      title: 'Monitoramento de Tickets da Blip',
      titlePage: 'Monitoramento da Blip',
      component: (<BlipMonitoringPage />),
      icon: (<TrackChanges />),
      to: 'blip_monitoring',
      display: (user?.blip_monitoring === 'Y') ? '' : 'none',
    }
  ];

  const buttonsHelpDesk = [
    { 
      id: 1,
      title: 'Publicações',
      titlePage: 'Publicações',
      component: (<PublicationsPage setComponent={setComponent} admin={true} />),
      icon: (<LanguageIcon />),
      to: 'h',
      display: (user?.helpdesk_pubs === 'Y') ? '' : 'none',
    },
    { 
      id: 2,
      title: 'Imagens',
      titlePage: 'Imagens',
      component: (<PageImages />),
      icon: (<PhotoLibraryIcon />),
      to: 'imagens',
      display: (user?.helpdesk_images === 'Y') ? '' : 'none',
    },
    { 
      id: 3,
      title: 'Categorias',
      titlePage: 'Categorias Publicações',
      component: (<PageCategories />),
      icon: (<CategoryIcon />),
      to: 'categorias',
      display: (user?.helpdesk_categories === 'Y') ? '' : 'none',
    },
  ]
  
  const buttonsAtt = [
    { 
      id: 1,
      title: 'Painel de Atualização',
      titlePage: 'Painel de Atualização',
      component: (<ClientsActualizations />),
      icon: (<BrowserUpdatedIcon/>),
      to: 'actualizations_clients',
      display: (user?.actualizations_panel === 'Y') ? '' : 'none',
    },
    { 
      id: 2,
      title: 'Versões Sistemas',
      titlePage: 'Versões Sistemas API de Atualização',
      component: (<SystemsTable />),
      icon: (<WidgetsIcon />),
      to: 'actualizations_systems',
      display: (user?.actualizations_files === 'Y') ? '' : 'none',
    },  
    { 
      id: 3,
      title: 'Usuários',
      titlePage: 'Usuários API de Atualização',
      component: (<UsersActualizationsPage/>),
      icon: (<GroupIcon />),
      to: 'actualizations_users',
      display: (user?.actualizations_users === 'Y') ? '' : 'none',
    }, 
    { 
      id: 4,
      title: 'Serviços Online',
      titlePage: 'Serviços Online',
      component: (<CloudServicesPage/>),
      icon: (<CloudSyncIcon/>),
      to: 'cloud_services',
      display: (user?.cloud_services === 'Y') ? '' : 'none',
    },
    { 
      id: 5,
      title: 'Anúncios do Sistema',
      titlePage: 'Anúncios do Sistema',
      component: (<AnnouncementsPage/>),
      icon: (<Campaign/>),
      to: 'system_ads',
      display: (user?.system_ads === 'Y') ? '' : 'none',
    } 
  ];

  const buttonsFiles = [
    { 
      id: 1,
      title: 'Arquivos',
      titlePage: 'Servidor de Arquivos',
      component: (<FilesPage />),
      icon: (<GroupIcon />),
      to: 'files',
      display: (user?.files_panel === 'Y') ? '' : 'none',
    },
    { 
      id: 2,
      title: 'Categorias',
      titlePage: 'Categorias de Arquivos',
      component: (<FilesPageCategories />),
      icon: (<WidgetsIcon />),
      to: 'files_categories',
      display: (user?.files_categories === 'Y') ? '' : 'none',
    },    
  ];

  const Manuais = { 
    id: 1,
    title: 'Manuais',
    titlePage: 'Manuais',
    component: (<Manuals admin={true}/>),
    icon: (<GroupIcon />),
    to: 'manuais',
  };

  const buttonsFinanceiro = [
    {
      id: 1,
      title: 'Painel Financeiro',
      titlePage: 'Painel Financeiro',
      component: (<FinanceiroPanelPage />),
      icon: (<MoneyIcon/>),
      to: 'financeiro',
      display: canAccessFinanceiro ? '' : 'none',
    },
    {
      id: 2,
      title: 'Relatorios Financeiros',
      titlePage: 'Relatorios Financeiros',
      component: (<FinanceiroReportsPage />),
      icon: (<QueryStatsIcon />),
      to: 'financeiro_relatorios',
      display: canAccessFinanceiro ? '' : 'none',
    },
  ];

  const buttonsAdm = [
    { 
      id: 1,
      title: 'Usuários',
      titlePage: 'Usuários',
      component: (<UsersPage />),
      icon: (<GroupIcon />),
      to: 'usuarios',
      display: (user?.administration_users === 'Y') ? '' : 'none',
    },
    { 
      id: 2,
      title: 'Grupos de Usuários',
      titlePage: 'Grupos de Usuários',
      component: (<UserGroupsPage />),
      icon: (<GroupIcon />),
      to: 'usuariosgrupos',
      display: (user?.administration_users_groups === 'Y') ? '' : 'none',
    },    
    { 
      id: 3,
      title: 'Clientes',
      titlePage: 'Clientes',
      component: (<ClientsPage />),
      icon: (<GroupIcon />),
      to: 'clientes',
      display: (user?.administration_clients === 'Y') ? '' : 'none',
    },
    {
      id: 4,
      title: 'Repositórios',
      titlePage: 'Repositórios',
      component: (<RepositoriesPage />),
      icon: (<GitHubIcon />),
      to: 'repositorios',
      display: (user?.manage_repositories === 'Y') ? '' : 'none',
    },
    {
      id: 5,
      title: 'Sistemas',
      titlePage: 'Sistemas',
      component: (<SystemsPage />),
      icon: (<AppsIcon />),
      to: 'sistemas',
      display: (user?.administration_systems === 'Y') ? '' : 'none',
    },
  ];

  return (
    <Box sx={{ display: 'flex'}}>
    <ThemeProvider theme={mode}>
      <CssBaseline />
      <CssBaseline />
      <AppBar position="fixed" open={open} >
        <Toolbar variant="dense">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 1, ...(open && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" >
            {pageTitle}
          </Typography>  
  
          <Box sx={{ position: 'fixed', right: '10px', display: "flex", 
              ...(open && { display: {xs: 'none', sm: "flex"} })
            }}>  
            <Box sx={{ p: 0,  mr: {xs: 1, sm: 2 }}}>
              <Tooltip title='Senha Diária' color='white'>
                <IconButton onClick={getDailyPassword} sx={{color: 'white'}} >
                  <KeyIcon/>
                </IconButton>
              </Tooltip>                
            </Box> 
            <Box sx={{ p: 0,  mr: {xs: 1, sm: 2 }}}>    
              {            
              (mode === lightTheme) ? 
              <Tooltip title='Apagar as luzes' color='white' display={"flex"}>
                <IconButton onClick={() => handleMode('dark')} sx={{  color: 'white' }}>
                  <Brightness4Icon />
                </IconButton>
              </Tooltip>  
              :
              <Tooltip title='Acender as luzes' color='white' >
              <IconButton onClick={() => handleMode('light')} sx={{color: 'white' }}>
                <Brightness7Icon />
              </IconButton>
              </Tooltip>    
              }
            </Box>
            <Box sx={{ p: 0 }}>  
              <Tooltip title='Sair' color='white'>
                <IconButton onClick={handleSignout} sx={{color: 'white' }}>
                  <LogoutIcon/>
                </IconButton>
              </Tooltip>
            </Box> 
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            height: '100vh'
          },
          
        }}
        variant="persistent"
        anchor="left"
        open={open}
        
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List sx={{fontSize: '12px'}}>
          <ListItemButton onClick={handleExpandRequests} sx={{display: (user?.requests === 'Y') ? '' : 'none',}}>
            <ListItemIcon>
              <SupportRoundedIcon />
            </ListItemIcon>
            <ListItemText primary="Atendimentos" />
            {expandedMenuRequests ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
            <Collapse in={expandedMenuRequests} timeout="auto" unmountOnExit sx={{ textAlign: "left", pl: 5}}>
              <List component="div" disablePadding>
              {buttonsRequests.map((item) => {
                    return (
                      <ListItemButton 
                        key={item.id} 
                        onClick={() => handleComponent(item)} 
                        sx={{display: item.display}}
                      >
                        <ListItemIcon>
                          {item.icon} 
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                    )
                  })}
              </List>
            </Collapse>
            <Divider />
            <ListItemButton onClick={handleExpandAtt} sx={{display: (user?.actualizations === 'Y') ? '' : 'none',}}>
              <ListItemIcon>
                 <CoPresentIcon/>
              </ListItemIcon>
              <ListItemText primary="Painel de Clientes" />
              {expandedMenuAtt ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={expandedMenuAtt} timeout="auto" unmountOnExit sx={{ textAlign: "left", pl: 5}}>
              <List component="div" disablePadding>
              {buttonsAtt.map((item) => {
                    return (
                      <ListItemButton 
                        key={item.id} 
                        onClick={() => handleComponent(item)} 
                        sx={{display: item.display}}
                      >
                        <ListItemIcon>
                          {item.icon} 
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                    )
              })}
              </List>
            </Collapse>
            <Divider />  
            <ListItemButton onClick={handleExpandFiles} sx={{display: (user?.files === 'Y') ? '' : 'none',}}>
              <ListItemIcon>
                <DriveFolderUploadIcon />
              </ListItemIcon>
              <ListItemText primary="Servidor de Arquivos" />
              {expandedMenuFiles ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={expandedMenuFiles} timeout="auto" unmountOnExit sx={{ textAlign: "left", pl: 5}}>
              <List component="div" disablePadding>
              {buttonsFiles.map((item) => {
                    return (
                      <ListItemButton 
                        key={item.id} 
                        onClick={() => handleComponent(item)} 
                        sx={{display: item.display}}
                      >
                        <ListItemIcon>
                          {item.icon} 
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                    )
              })}
              </List>
            </Collapse>           
            <Divider />
            <ListItemButton onClick={handleExpandFinanceiro} sx={{display: canAccessFinanceiro ? '' : 'none',}}>
              <ListItemIcon>
                <AttachMoneyIcon />
              </ListItemIcon>
              <ListItemText primary="Financeiro" />
              {expandedMenuFinanceiro ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={expandedMenuFinanceiro} timeout="auto" unmountOnExit sx={{ textAlign: "left", pl: 5}}>
              <List component="div" disablePadding>
              {buttonsFinanceiro.map((item) => {
                    return (
                      <ListItemButton
                        key={item.id}
                        onClick={() => handleComponent(item)}
                        sx={{display: item.display}}
                      >
                        <ListItemIcon>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                    )
              })}
              </List>
            </Collapse>
            <ListItem
              disablePadding
              onClick={() => handleComponent(Manuais)}>
              <ListItemButton>
                <ListItemIcon>
                  <QuizIcon /> 
                </ListItemIcon>
                <ListItemText primary={"Manuais"} />
              </ListItemButton>
            </ListItem>
            <Divider />
            <ListItemButton onClick={handleExpandHelpDesk} sx={{display: (user?.helpdesk === 'Y') ? '' : 'none',}}>
              <ListItemIcon>
                <HelpIcon />
              </ListItemIcon>
              <ListItemText primary="Base de Conhecimento" />
              {expandedMenuHelpDesk ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={expandedMenuHelpDesk} timeout="auto" unmountOnExit sx={{ textAlign: "left", pl: 5}}>
              <List component="div" disablePadding>
              {buttonsHelpDesk.map((item) => {
                    return (
                      <ListItemButton 
                        key={item.id} 
                        onClick={() => handleComponent(item)}
                        sx={{display: item.display}}
                      >
                        <ListItemIcon>
                          {item.icon} 
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                    )
              })}
              </List>
            </Collapse>
            <Divider /> 
            {/* Menus Administrativos  */}
            <ListItemButton onClick={handleExpandAdm} sx={{display: (user?.administration === 'Y') ? '' : 'none',}}>
              <ListItemIcon>
                <DisplaySettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Administração" />
              {expandedMenuAdm ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={expandedMenuAdm} timeout="auto" unmountOnExit sx={{ textAlign: "left", pl: 5}}>
              <List component="div" disablePadding>
              {buttonsAdm.map((item) => {
                    return (
                      <ListItemButton 
                        key={item.id} 
                        onClick={() => handleComponent(item)} 
                        sx={{display: item.display}}
                      >
                        <ListItemIcon>
                          {item.icon} 
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                    )
                  })}
              </List>
            </Collapse>    
            {/* {
              menus.map((item) => (
                <>
                  <ListItemButton onClick={() => handleExpandMenu(item.name)} sx={{display: item.display}}>
                    <ListItemIcon>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.title} />
                    {expandedMenu === item.name ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={expandedMenu === item.name} timeout="auto" unmountOnExit sx={{ textAlign: "left", pl: 5}}>
                    <List component="div" disablePadding>
                      {item.buttons.map((button) => (                     
                            <ListItemButton 
                              key={button.id} 
                              onClick={() => handleComponent(button.component , button.to, button.title)} 
                              sx={{display: button.display}}
                            >
                              <ListItemIcon>
                                {button.icon} 
                              </ListItemIcon>
                              <ListItemText primary={button.title} />
                            </ListItemButton>  
                      ))
                      }
                    </List>
                  </Collapse>
              </>
              ))
            } */}
        </List>
        <div className='div-by' >
          <p>&copy;Sirrus Sistemas {new Date().getFullYear()}</p>
        </div>  
      </Drawer>
      <Main open={open} onClick={handleDrawerClose} sx={{height: '100%', mt: 5}}>
        {/* <DrawerHeader /> */}
        {component}
      </Main>
      </ThemeProvider>
    </Box>
  );
}
